// extracted by mini-css-extract-plugin
export default {"container":"styles_container__s+V4d","title":"styles_title__c-n8a","coverImage":"styles_coverImage__v83Rh","card":"styles_card__j+XIU"};